import { useGetCustomerDataFeedStatusQuery } from '@autone/redux/assortment';

export const useAssortmentDataFeedStatus = () => {
  const { data, isLoading } = useGetCustomerDataFeedStatusQuery({});

  return {
    isAssortmentDataFeedActive: data?.use_data_feed_for_assortment ?? false,
    isInitialAllocationDataFeedActive:
      data?.use_data_feed_for_initial_allocation ?? false,
    isLoading,
  };
};
